import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { createElement } from "react";
import { HorizontalPanelDragHandle } from "./HorizontalPanelDragHandle";
import {
  DragDropContext,
  Droppable,
  Draggable as DndDraggable
} from "@hello-pangea/dnd";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState
} from "react";
import { connect } from "react-redux";
import {
  Button,
  Intent,
  Tooltip,
  Icon,
  Spinner,
  AnchorButton,
  EditableText
} from "@blueprintjs/core";
import { InfoHelper, Loading, showContextMenu, withStore } from "@teselagen/ui";
import { store as _store } from "@risingstack/react-easy-state";
import { throttle, map, some, isFunction, unset, omit } from "lodash-es";
import { getSequenceDataBetweenRange } from "@teselagen/sequence-utils";
import ReactList from "@teselagen/react-list";
import ReactDOM from "react-dom";
import shortid from "shortid";
import { NonReduxEnhancedLinearView } from "../LinearView";
import Minimap, { getTrimmedRangesToDisplay } from "./Minimap";
import { compose, branch, renderComponent } from "recompose";
import AlignmentVisibilityTool from "./AlignmentVisibilityTool";
import * as alignmentActions from "../redux/alignments";
import _estimateRowHeight from "../RowView/estimateRowHeight";
import prepareRowData from "../utils/prepareRowData";
import withEditorProps from "../withEditorProps";
import "./style.css";
import {
  editorDragged,
  editorClicked,
  editorDragStarted,
  updateSelectionOrCaret as _updateSelectionOrCaret,
  editorDragStopped
} from "../withEditorInteractions/clickAndDragUtils";
import { ResizeSensor } from "@blueprintjs/core";
import ReactDraggable from "react-draggable";
import draggableClassnames from "../constants/draggableClassnames";
import Caret from "../RowItem/Caret";
import { debounce } from "lodash-es";
import { view } from "@risingstack/react-easy-state";
import { noop } from "lodash-es";
import { massageTickSpacing } from "../utils/massageTickSpacing";
import { getClientX, getClientY } from "../utils/editorUtils";
import UncontrolledSliderWithPlusMinusBtns from "../helperComponents/UncontrolledSliderWithPlusMinusBtns";
import { updateLabelsForInViewFeatures } from "../utils/updateLabelsForInViewFeatures";
import PinchHelper from "../helperComponents/PinchHelper/PinchHelper";
import { showDialog } from "../GlobalDialogUtils";
import { GlobalDialog } from "../GlobalDialog";
import { array_move } from "../ToolBar/array_move";
import classNames from "classnames";
import { getTrackFromEvent, getTrackDisplayName } from "./getTrackFromEvent";
import { PerformantSelectionLayer } from "./PerformantSelectionLayer";
import { PairwiseAlignmentView } from "./PairwiseAlignmentView";
import { updateTrackHelper } from "./updateTrackHelper";
import { isTargetWithinEl } from "./isTargetWithinEl";
import { EditTrackNameDialog } from "./EditTrackNameDialog";
import { coerceInitialValue } from "./coerceInitialValue";
import { tabHeight } from "../constants";
import LabileSitesLayer from "./LabileSitesLayer";
import PropertySidePanel from "../PropertySidePanel";
import {
  getAlignedAminoAcidSequenceProps,
  getLabileSites,
  parseTracks
} from "../utils/getAlignedAminoAcidSequenceProps";
let charWidthInLinearViewDefault = 12;
try {
  const newVal = JSON.parse(
    window.localStorage.getItem("charWidthInLinearViewDefault")
  );
  if (newVal) charWidthInLinearViewDefault = newVal;
} catch (e) {
  console.error(
    "error setting charWidthInLinearViewDefault from local storage:",
    e
  );
}
export const AlignmentView = (props) => {
  const {
    dimensions,
    alignmentType,
    alignmentRunUpdate,
    alignmentName: _alignmentName,
    caretPosition,
    handleAlignmentSave,
    id,
    isFullyZoomedOut,
    scrollPercentageToJumpTo,
    selectionLayer,
    sequenceData,
    shouldAutosave,
    store,
    height: _height,
    minimapLaneHeight,
    minimapLaneSpacing,
    isInPairwiseOverviewView,
    noVisibilityOptions,
    handleBackButtonClicked,
    allowTrimming,
    additionalSelectionLayerRightClickedOptions,
    selectionLayerRightClicked,
    additionalTopEl,
    additionalTopLeftEl,
    handleAlignmentRename,
    stateTrackingId,
    style,
    unmappedSeqs
  } = props;
  let height = _height;
  if (dimensions && dimensions.height) {
    height = dimensions.height - tabHeight;
  }
  const {
    alignmentId,
    alignmentTrackIndex,
    alignmentTracks = [],
    alignmentVisibilityToolOptions,
    allowTrackNameEdit,
    allowTrackRearrange,
    currentPairwiseAlignmentIndex,
    handleSelectTrack,
    hasTemplate,
    isPairwise,
    linearViewOptions,
    noClickDragHandlers,
    pairwiseAlignments,
    pairwiseOverviewAlignmentTracks,
    upsertAlignmentRun,
    ...rest
  } = props;
  const [width, setWidth] = useState(0);
  const [nameDivWidth, setNameDivWidth] = useState(140);
  const [charWidthInLinearView, _setCharWidthInLinearView] = useState(
    charWidthInLinearViewDefault
  );
  const [alignmentName, setAlignmentName] = useState(_alignmentName);
  const [isTrackDragging, setIsTrackDragging] = useState(false);
  const [saveMessage, setSaveMessage] = useState();
  const [saveMessageLoading, setSaveMessageLoading] = useState(false);
  const [tempTrimBefore, setTempTrimBefore] = useState({});
  const [tempTrimAfter, setTempTrimAfter] = useState({});
  const [tempTrimmingCaret, setTempTrimmingCaret] = useState({});
  const bindOutsideChangeHelper = useRef({});
  const alignmentHolder = useRef(null);
  const alignmentHolderTop = useRef(null);
  const veTracksAndAlignmentHolder = useRef(null);
  const InfiniteScroller = useRef(null);
  const oldAlignmentHolderScrollTop = useRef(0);
  const blockScroll = useRef(false);
  const isZooming = useRef(false);
  const rowData = useRef({});
  const latestMouseY = useRef();
  const easyStore = useRef(
    _store({
      selectionLayer: { start: -1, end: -1 },
      caretPosition: -1,
      percentScrolled: 0,
      viewportWidth: 400,
      verticalVisibleRange: { start: 0, end: 0 }
    })
  );
  const [propertySidePanel, setPropertySidePanel] = useState({
    isOpen: false,
    selection: null,
    track: null,
    isPairwise: false
  });
  const getAllAlignmentsFastaText = useCallback(() => {
    const selectionLayer2 = store.getState().VectorEditor.__allEditorsOptions.alignments[id].selectionLayer || {};
    const seqDataOfAllTracksToCopy = [];
    alignmentTracks.forEach((track) => {
      const seqDataToCopy = getSequenceDataBetweenRange(
        track.alignmentData,
        selectionLayer2
      ).sequence;
      seqDataOfAllTracksToCopy.push(
        `>${track.alignmentData.name}\r
${seqDataToCopy}\r
`
      );
    });
    return seqDataOfAllTracksToCopy.join("");
  }, [alignmentTracks, id, store]);
  const scrollAlignmentToPercent = (scrollPercentage) => {
    const scrollPercentageToUse = Math.min(Math.max(scrollPercentage, 0), 1);
    easyStore.current.percentScrolled = scrollPercentageToUse;
    alignmentHolder.current.scrollLeft = scrollPercentageToUse * (alignmentHolder.current.scrollWidth - alignmentHolder.current.clientWidth);
    if (alignmentHolderTop.current) {
      alignmentHolderTop.current.scrollLeft = scrollPercentageToUse * (alignmentHolderTop.current.scrollWidth - alignmentHolderTop.current.clientWidth);
    }
  };
  const aminoAcidAlignmentProperties = useMemo(() => {
    if (isPairwise || !alignmentTracks[0].sequenceData.isProtein) return;
    return getAlignedAminoAcidSequenceProps(alignmentTracks);
  }, [alignmentTracks, isPairwise]);
  useEffect(() => {
    window.scrollAlignmentToPercent = scrollAlignmentToPercent;
    if (window.Cypress)
      window.Cypress.scrollAlignmentToPercent = scrollAlignmentToPercent;
    return () => {
      delete window.scrollAlignmentToPercent;
      if (window.Cypress) delete window.Cypress.scrollAlignmentToPercent;
    };
  }, []);
  const {
    alignmentAnnotationVisibility,
    togglableAlignmentAnnotationSettings
  } = alignmentVisibilityToolOptions;
  useEffect(() => {
    const dnaAnnotations = [
      "chromatogram",
      "reverseSequence",
      "cdsFeatureTranslations",
      "dnaColors",
      "translations",
      "compactNames"
    ];
    const aminoAcidAnnotations = [
      "physicalProperties",
      "serineThreonine",
      "labileSites",
      "colorScheme",
      "plot",
      "conservation",
      "properties",
      "hydrophobicity",
      "polar",
      "negative",
      "positive",
      "charged",
      "aliphatic",
      "aromatic",
      "compactNames"
    ];
    const noNeededAnnotationsForPairwise = ["plot", "labileSites"];
    if (alignmentTracks[0].sequenceData.isProtein) {
      dnaAnnotations.forEach((key) => {
        delete alignmentAnnotationVisibility[key];
        delete togglableAlignmentAnnotationSettings[key];
      });
      aminoAcidAnnotations.forEach((key) => {
        alignmentAnnotationVisibility[key] = false;
        togglableAlignmentAnnotationSettings[key] = false;
      });
      if (isPairwise) {
        noNeededAnnotationsForPairwise.forEach((key) => {
          delete alignmentAnnotationVisibility[key];
          delete togglableAlignmentAnnotationSettings[key];
        });
      }
    } else {
      aminoAcidAnnotations.forEach((key) => {
        delete alignmentAnnotationVisibility[key];
        delete togglableAlignmentAnnotationSettings[key];
      });
    }
  }, [alignmentTracks, isPairwise]);
  const maxLength = useMemo(() => {
    const { sequenceData: sequenceData2 = { sequence: "" }, alignmentData } = alignmentTracks[0];
    const data = alignmentData || sequenceData2;
    return data.noSequence ? data.size : data.sequence.length;
  }, [alignmentTracks]);
  const getSequenceLength = useCallback(() => {
    return alignmentTracks?.[0]?.alignmentData?.sequence?.length || 1;
  }, [alignmentTracks]);
  const getMinCharWidth = useCallback(
    (noNameDiv) => {
      const toReturn = Math.min(
        Math.max(width - (noNameDiv ? 0 : nameDivWidth) - 5, 1) / getSequenceLength(),
        10
      );
      if (isNaN(toReturn)) return 10;
      return toReturn;
    },
    [getSequenceLength, nameDivWidth, width]
  );
  const charWidth = useMemo(() => {
    if (isFullyZoomedOut) {
      return getMinCharWidth();
    } else {
      return Math.max(getMinCharWidth(), charWidthInLinearView);
    }
  }, [charWidthInLinearView, getMinCharWidth, isFullyZoomedOut]);
  const debouncedAlignmentRunUpdate = debounce(alignmentRunUpdate, 1e3);
  const caretPositionUpdate = useCallback(
    (position) => {
      if ((caretPosition || -1) === position) {
        return;
      }
      easyStore.current.caretPosition = position;
      easyStore.current.selectionLayer = { start: -1, end: -1 };
      debouncedAlignmentRunUpdate({
        alignmentId,
        selectionLayer: { start: -1, end: -1 },
        caretPosition: position
      });
    },
    [alignmentId, caretPosition, debouncedAlignmentRunUpdate]
  );
  const selectionLayerUpdate = useCallback(
    (newSelection, { forceReduxUpdate } = {}) => {
      const usableSelectionLayer = selectionLayer || { start: -1, end: -1 };
      if (!newSelection) return;
      const { start, end } = newSelection;
      if (usableSelectionLayer.start === start && usableSelectionLayer.end === end) {
        return;
      }
      easyStore.current.caretPosition = -1;
      easyStore.current.selectionLayer = newSelection;
      (forceReduxUpdate ? alignmentRunUpdate : debouncedAlignmentRunUpdate)({
        alignmentId,
        selectionLayer: newSelection,
        caretPosition: -1
      });
    },
    [
      alignmentId,
      alignmentRunUpdate,
      debouncedAlignmentRunUpdate,
      selectionLayer
    ]
  );
  const updateSelectionOrCaret = useCallback(
    (shiftHeld, newRangeOrCaret, { forceReduxUpdate } = {}) => {
      const forceReduxSelectionLayerUpdate = (newSelection) => {
        selectionLayerUpdate(newSelection, { forceReduxUpdate: true });
      };
      const sequenceLength = getSequenceLength();
      _updateSelectionOrCaret({
        doNotWrapOrigin: true,
        shiftHeld,
        sequenceLength,
        newRangeOrCaret,
        caretPosition: easyStore.current.caretPosition,
        selectionLayer: easyStore.current.selectionLayer,
        selectionLayerUpdate: forceReduxUpdate ? forceReduxSelectionLayerUpdate : selectionLayerUpdate,
        caretPositionUpdate
      });
    },
    [caretPositionUpdate, getSequenceLength, selectionLayerUpdate]
  );
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "c" && !event.shiftKey && (event.metaKey === true || event.ctrlKey === true)) {
        if (!document.activeElement?.classList.contains("alignmentView")) {
          return;
        }
        const input = document.createElement("textarea");
        document.body.appendChild(input);
        const seqDataOfAllTracksToCopy = getAllAlignmentsFastaText();
        input.value = seqDataOfAllTracksToCopy;
        input.select();
        const copySuccess = document.execCommand("copy");
        if (!copySuccess) {
          window.toastr.error("Selection Not Copied");
        } else {
          window.toastr.success("Selection Copied");
        }
        document.body.removeChild(input);
        event.preventDefault();
        document.activeElement?.blur();
        document.querySelector(".alignmentView")?.focus();
      } else if (event.key === "Escape") {
        if (!document.activeElement?.classList.contains("alignmentView")) {
          return;
        }
        if (handleBackButtonClicked) {
          handleBackButtonClicked();
          caretPositionUpdate(-1);
          event.preventDefault();
        }
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [getAllAlignmentsFastaText, handleBackButtonClicked, caretPositionUpdate]);
  const getNearestCursorPositionToMouseEvent = useCallback(
    (_, event, callback) => {
      let nearestCaretPos = 0;
      const rowDomNode = veTracksAndAlignmentHolder.current;
      const boundingRowRect = rowDomNode.getBoundingClientRect();
      if (getClientX(event) - boundingRowRect.left - nameDivWidth < 0) {
        nearestCaretPos = 0;
      } else {
        const clickXPositionRelativeToRowContainer = getClientX(event) - boundingRowRect.left - nameDivWidth;
        const numberOfBPsInFromRowStart = Math.floor(
          (clickXPositionRelativeToRowContainer + charWidth / 2) / charWidth
        );
        nearestCaretPos = numberOfBPsInFromRowStart + 0;
        if (nearestCaretPos > maxLength + 1) {
          nearestCaretPos = maxLength + 1;
        }
      }
      if (sequenceData?.isProtein) {
        nearestCaretPos = Math.round(nearestCaretPos / 3) * 3;
      }
      const sequenceLength = getSequenceLength();
      if (sequenceLength === 0) nearestCaretPos = 0;
      const callbackVals = {
        updateSelectionOrCaret,
        nearestCaretPos,
        sequenceLength,
        caretPosition: easyStore.current.caretPosition,
        selectionLayer: easyStore.current.selectionLayer,
        easyStore: easyStore.current,
        caretPositionUpdate,
        selectionLayerUpdate,
        event,
        doNotWrapOrigin: true,
        shiftHeld: event.shiftKey,
        // caretGrabbed: event.target.className === "cursor",
        selectionStartGrabbed: event.target.classList.contains(
          draggableClassnames.selectionStart
        ),
        selectionEndGrabbed: event.target.classList.contains(
          draggableClassnames.selectionEnd
        )
      };
      callback(callbackVals);
      setPropertySidePanel((prev) => {
        return {
          ...prev,
          selection: easyStore.current.selectionLayer
        };
      });
    },
    [
      caretPositionUpdate,
      charWidth,
      getSequenceLength,
      maxLength,
      nameDivWidth,
      selectionLayerUpdate,
      sequenceData?.isProtein,
      updateSelectionOrCaret
    ]
  );
  useEffect(() => {
    const updateAlignmentSelection = (newRangeOrCaret) => {
      updateSelectionOrCaret(false, newRangeOrCaret, {
        forceReduxUpdate: true
      });
    };
    window.updateAlignmentSelection = updateAlignmentSelection;
    if (window.Cypress)
      window.Cypress.updateAlignmentSelection = updateAlignmentSelection;
    return () => {
      delete window.updateAlignmentSelection;
      if (window.Cypress) {
        delete window.Cypress.updateAlignmentSelection;
      }
    };
  }, [updateSelectionOrCaret]);
  const setVerticalScrollRange = throttle(() => {
    if (InfiniteScroller.current && InfiniteScroller.current.getFractionalVisibleRange && easyStore.current) {
      let [start, end] = InfiniteScroller.current.getFractionalVisibleRange();
      if (hasTemplate) {
        end = end + 1;
      }
      if (easyStore.current.verticalVisibleRange.start !== start || easyStore.current.verticalVisibleRange.end !== end)
        easyStore.current.verticalVisibleRange = { start, end };
    }
  }, 100);
  useEffect(() => {
    setTimeout(() => {
      updateLabelsForInViewFeatures({ rectElement: ".alignmentHolder" });
    }, 0);
    setTimeout(() => {
      setVerticalScrollRange();
    }, 500);
  });
  useEffect(() => {
    if (scrollPercentageToJumpTo !== void 0) {
      scrollAlignmentToPercent(scrollPercentageToJumpTo);
    }
  }, [scrollPercentageToJumpTo]);
  const lastSavedStateRef = useRef({});
  const lastIdRef = useRef();
  if (lastIdRef.current !== id) {
    lastIdRef.current = id;
    if (stateTrackingId) {
      lastSavedStateRef.current[id] = stateTrackingId;
    }
  }
  useEffect(() => {
    const saveAlignment = async () => {
      if (shouldAutosave && stateTrackingId && stateTrackingId !== "initialLoadId" && stateTrackingId !== lastSavedStateRef.current[id] && handleAlignmentSave) {
        lastSavedStateRef.current[id] = stateTrackingId;
        setSaveMessage("Alignment Saving..");
        setSaveMessageLoading(true);
        let cleanedTracks;
        if (pairwiseAlignments) {
          cleanedTracks = pairwiseAlignments.map(cleanTracks);
        } else {
          cleanedTracks = cleanTracks(alignmentTracks);
        }
        await handleAlignmentSave(cleanedTracks);
        setSaveMessage("Alignment Saved");
        setSaveMessageLoading(false);
        setTimeout(() => {
          setSaveMessage(void 0);
          setSaveMessageLoading(false);
        }, 5e3);
      }
    };
    saveAlignment();
  }, [
    id,
    alignmentTracks,
    handleAlignmentSave,
    pairwiseAlignments,
    shouldAutosave,
    stateTrackingId
  ]);
  const annotationClicked = ({
    event,
    annotation,
    gapsBefore = 0,
    gapsInside = 0
  }) => {
    event.preventDefault && event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    updateSelectionOrCaret(event.shiftKey, {
      ...annotation,
      start: annotation.start + gapsBefore,
      end: annotation.end + gapsBefore + gapsInside
    });
  };
  const getFeatureRightClicked = (trackIndex, tracksToMap) => ({
    event,
    annotation
  }) => {
    event.preventDefault && event.preventDefault();
    event.stopPropagation && event.stopPropagation();
    const otherTracks2 = tracksToMap.map((t, idx) => ({ ...t, idx })).filter((t, idx) => idx !== trackIndex);
    if (!otherTracks2.length) return;
    const copyFeatureToTrack = (targetTrackIndex) => {
      const featureToCopy = {
        ...omit(annotation, ["id", "overlapsSelf"]),
        id: shortid()
      };
      const sourceTrack = tracksToMap[trackIndex];
      const targetTracks = targetTrackIndex === "all" ? otherTracks2.map((t) => t.idx) : [targetTrackIndex];
      if (targetTracks.length === 1) {
        const idx = targetTracks[0];
        const trackToUpdate = tracksToMap[idx];
        const newFeatures = [...trackToUpdate.sequenceData.features || [], featureToCopy];
        updateTrackHelper({
          currentPairwiseAlignmentIndex,
          pairwiseAlignments,
          upsertAlignmentRun,
          alignmentId,
          alignmentTracks: tracksToMap || [],
          alignmentTrackIndex: idx,
          update: { features: newFeatures }
        });
      } else {
        if (pairwiseAlignments) {
          const newPairwiseAlignments = pairwiseAlignments.map((ats) => {
            const alignedTrack = ats[1];
            return [
              ats[0],
              {
                ...alignedTrack,
                sequenceData: {
                  ...alignedTrack.sequenceData,
                  features: [...alignedTrack.sequenceData.features || [], featureToCopy]
                },
                alignmentData: {
                  ...alignedTrack.alignmentData,
                  features: [...alignedTrack.alignmentData.features || [], featureToCopy]
                }
              }
            ];
          });
          upsertAlignmentRun({
            id: alignmentId,
            pairwiseAlignments: newPairwiseAlignments
          });
        } else {
          const newAlignmentTracks = tracksToMap.map((track, idx) => {
            if (targetTracks.includes(idx)) {
              return {
                ...track,
                sequenceData: {
                  ...track.sequenceData,
                  features: [...track.sequenceData.features || [], featureToCopy]
                },
                alignmentData: {
                  ...track.alignmentData,
                  features: [...track.alignmentData.features || [], featureToCopy]
                }
              };
            }
            return track;
          });
          upsertAlignmentRun({
            id: alignmentId,
            alignmentTracks: newAlignmentTracks
          });
        }
      }
      window.toastr.success(`Feature copied successfully`);
    };
    const menuItems = [
      {
        text: "Copy feature to...",
        className: "copy-feature-to-submenu",
        submenu: [
          ...otherTracks2.map((t) => ({
            text: t.sequenceData.name || t.sequenceData.id || `Track ${t.idx + 1}`,
            onClick: () => copyFeatureToTrack(t.idx)
          })),
          { text: "All other sequences", onClick: () => copyFeatureToTrack("all") }
        ]
      }
    ];
    showContextMenu(menuItems, void 0, event);
  };
  const getNumBpsShownInLinearView = () => {
    const toReturn = (width - nameDivWidth) / charWidth;
    return toReturn || 0;
  };
  const handleScroll = () => {
    if (alignmentHolder.current.scrollTop !== oldAlignmentHolderScrollTop.current) {
      setTimeout(() => {
        setVerticalScrollRange();
        oldAlignmentHolderScrollTop.current = alignmentHolder.current.scrollTop;
      }, 100);
    }
    if (blockScroll.current) {
      return;
    }
    const scrollPercentage = alignmentHolder.current.scrollLeft / (alignmentHolder.current.scrollWidth - alignmentHolder.current.clientWidth);
    easyStore.current.percentScrolled = scrollPercentage || 0;
    if (!isZooming.current) {
      easyStore.current.percentScrolledPreZoom = easyStore.current.percentScrolled;
    }
    if (alignmentHolderTop.current) {
      alignmentHolderTop.current.scrollLeft = alignmentHolder.current.scrollLeft;
    }
    updateLabelsForInViewFeatures({ rectElement: ".alignmentHolder" });
  };
  const handleTopScroll = () => {
    alignmentHolder.current.scrollLeft = alignmentHolderTop.current.scrollLeft;
  };
  const onMinimapSizeAdjust = (newSliderSize, newPercent) => {
    const percentageOfSpace = newSliderSize / width;
    const seqLength = getSequenceLength();
    const numBpsInView = seqLength * percentageOfSpace;
    const newCharWidth = (width - nameDivWidth) / numBpsInView;
    blockScroll.current = true;
    setCharWidthInLinearView({ charWidthInLinearView: newCharWidth });
    setTimeout(() => {
      scrollAlignmentToPercent(newPercent);
      blockScroll.current = false;
      updateLabelsForInViewFeatures({ rectElement: ".alignmentHolder" });
    });
  };
  const setCharWidthInLinearView = ({ charWidthInLinearView: charWidthInLinearView2 }) => {
    window.localStorage.setItem(
      "charWidthInLinearViewDefault",
      charWidthInLinearView2
    );
    _setCharWidthInLinearView(charWidthInLinearView2);
    charWidthInLinearViewDefault = JSON.parse(
      window.localStorage.getItem("charWidthInLinearViewDefault")
    );
  };
  const scrollToCaret = () => {
    let el = window.document.querySelector(".veCaret:not(.zoomSelection)");
    if (!el) {
      el = window.document.querySelector(".veCaret");
    }
    if (!el) {
      return;
    }
    el.scrollIntoView({ inline: "center", block: "nearest" });
  };
  const scrollYToTrack = (trackIndex) => {
    InfiniteScroller.current.scrollTo(trackIndex);
  };
  const estimateRowHeight = (index, cache) => {
    const track = hasTemplate ? alignmentTracks[index + 1] : alignmentTracks[index];
    if (!track) return 100;
    const { sequenceData: sequenceData2 } = track;
    rowData.current = prepareRowData(
      sequenceData2,
      sequenceData2.sequence.length
    );
    return _estimateRowHeight({
      index,
      cache,
      row: rowData.current[0],
      annotationVisibility: alignmentVisibilityToolOptions.alignmentAnnotationVisibility,
      annotationLabelVisibility: alignmentVisibilityToolOptions.alignmentAnnotationLabelVisibility
    });
  };
  const renderItem = (_i, _key, isTemplate, cloneProps) => {
    const isDragDisabled = !allowTrackRearrange || isPairwise;
    let i;
    if (isTemplate) {
      i = _i;
    } else if (hasTemplate) {
      i = _i + 1;
    } else {
      i = _i;
    }
    const track = alignmentTracks?.[i];
    if (!track) return null;
    const {
      sequenceData: sequenceData2,
      alignmentData,
      isReversed,
      wasTrimmed,
      additionalSelectionLayers,
      chromatogramData,
      strand
      // mismatches
    } = track;
    const isReversedToUse = isReversed || strand === -1;
    const seqLen = maxLength;
    const trimmedRangesToDisplay = getTrimmedRangesToDisplay({
      seqLen,
      trimmedRange: alignmentData?.trimmedRange
    });
    const linearViewWidth = (alignmentData || sequenceData2).sequence.length * charWidth;
    const name = alignmentData.name || sequenceData2.name || sequenceData2.id;
    const tickSpacing = massageTickSpacing(Math.ceil(120 / charWidth));
    const { compactNames } = alignmentVisibilityToolOptions.alignmentAnnotationVisibility;
    const selectionLayer2 = [
      tempTrimBefore[i] || trimmedRangesToDisplay[0],
      tempTrimAfter[i] || trimmedRangesToDisplay[1]
    ].filter((i2) => i2).map((i2) => ({
      ...i2,
      hideCarets: true,
      ignoreGaps: true,
      className: "tg-trimmed-region",
      color: "gray"
    }));
    const trackIdentifier = track?.sequenceData.id ? "id" : "hash";
    const selectedTrack = propertySidePanel?.track;
    const isTrackSelected = selectedTrack?.sequenceData[trackIdentifier] === track?.sequenceData[trackIdentifier];
    let aaIdentity;
    let aaIdenticalPosition;
    if (sequenceData2.isProtein && !isPairwise) {
      aaIdentity = aminoAcidAlignmentProperties?.matrix?.[0]?.[i]?.toFixed(1);
      aaIdenticalPosition = aminoAcidAlignmentProperties?.identicalPositions?.[i - 1]?.identicalPositions;
      if (sequenceData2.name === "Consensus") {
        sequenceData2.aminoAcidProperties = isPairwise || !sequenceData2.isProtein ? null : aminoAcidAlignmentProperties;
      }
    }
    const innerRenderItem = (provided = {}, snapshot) => /* @__PURE__ */ createElement(
      "div",
      {
        ref: provided?.innerRef,
        ...provided?.draggableProps,
        className: classNames("alignmentViewTrackContainer", {
          isDragDisabled,
          isTrackSelected
        }),
        "data-alignment-track-index": i,
        style: {
          boxShadow: isTemplate ? "red 0px -1px 0px 0px inset, red 0px 1px 0px 0px inset" : "0px -1px 0px 0px inset",
          display: "flex",
          ...provided?.draggableProps?.style,
          ...snapshot?.isDragging && { left: unset }
        },
        key: i,
        onClick: () => {
          setPropertySidePanel((prev) => {
            return {
              ...prev,
              selection: easyStore.current.selectionLayer,
              track,
              isPairwise
            };
          });
        }
      },
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: "alignmentTrackName",
          style: {
            position: "sticky",
            left: 0,
            zIndex: 10,
            borderBottom: `1px solid ${isTemplate ? "red" : "lightgray"}`,
            borderRight: `1px solid ${isTemplate ? "red" : "lightgray"}`,
            width: nameDivWidth - 3,
            padding: 2,
            marginRight: 3,
            paddingBottom: 0,
            minWidth: nameDivWidth - 3,
            overflow: "hidden",
            scrollbarWidth: "none",
            whiteSpace: "nowrap"
          },
          "data-title": name,
          children: [
            /* @__PURE__ */ jsxs(
              "div",
              {
                ...provided?.dragHandleProps,
                style: {
                  ...compactNames && {
                    display: "flex",
                    alignItems: "flex-start"
                  },
                  cursor: !isPairwise && allowTrackRearrange && !isTemplate ? "move" : ""
                },
                children: [
                  /* @__PURE__ */ jsxs(
                    "div",
                    {
                      className: "alignmentTrackNameDiv",
                      style: {
                        background: "#3FA6DA",
                        display: "inline-block",
                        color: "white",
                        borderRadius: 5,
                        paddingRight: 5,
                        ...compactNames && {
                          marginRight: 5
                        }
                      },
                      children: [
                        allowTrackNameEdit && /* @__PURE__ */ jsx(
                          Button,
                          {
                            onClick: () => {
                              showDialog({
                                ModalComponent: EditTrackNameDialog,
                                props: {
                                  initialValues: {
                                    name
                                  },
                                  updateName: ({ newName }) => {
                                    updateTrackHelper({
                                      currentPairwiseAlignmentIndex,
                                      pairwiseAlignments,
                                      upsertAlignmentRun,
                                      alignmentId,
                                      alignmentTracks: alignmentTracks || [],
                                      alignmentTrackIndex: i,
                                      update: { name: newName }
                                    });
                                  }
                                }
                              });
                            },
                            small: true,
                            "data-tip": "Edit Track Name",
                            className: "edit-track-name-btn",
                            icon: /* @__PURE__ */ jsx(Icon, { size: 12, color: "lightgrey", icon: "edit" }),
                            minimal: true
                          }
                        ),
                        sequenceData2.seqLink && /* @__PURE__ */ jsx(
                          AnchorButton,
                          {
                            href: sequenceData2.seqLink,
                            "data-tip": sequenceData2.seqLinkTooltip,
                            target: "_blank",
                            small: true,
                            icon: /* @__PURE__ */ jsx(Icon, { size: 12, color: "white", icon: "document-open" }),
                            minimal: true
                          }
                        ),
                        name
                      ]
                    }
                  ),
                  /* @__PURE__ */ jsxs("div", { style: { fontSize: 10, marginTop: 2, marginBottom: 2 }, children: [
                    isReversedToUse && /* @__PURE__ */ jsxs(
                      "span",
                      {
                        style: {
                          backgroundColor: isReversedToUse ? "#E76A6E" : "#4C90F0",
                          padding: 2,
                          paddingLeft: 4,
                          color: "white",
                          marginRight: 2,
                          borderRadius: "5px"
                        },
                        "data-tip": isReversedToUse ? "The alignment algorithm matched the reverse complement of this input sequence" : "The original sequence was NOT reversed complemented by the alignment algorithm",
                        children: [
                          isReversedToUse ? "REV" : "FWD",
                          " "
                        ]
                      }
                    ),
                    wasTrimmed && /* @__PURE__ */ jsx(
                      "span",
                      {
                        style: {
                          backgroundColor: "#13C9BA",
                          padding: 2,
                          paddingLeft: 4,
                          color: "white",
                          marginRight: 2,
                          borderRadius: "5px"
                        },
                        "data-tip": "This sequence was trimmed and resubmitted for alignment",
                        children: "TRIMMED"
                      }
                    ),
                    sequenceData2.isProtein ? /* @__PURE__ */ jsxs(Fragment, { children: [
                      /* @__PURE__ */ jsxs("span", { children: [
                        sequenceData2.proteinSequence.length,
                        " AAs"
                      ] }),
                      !compactNames && i > 0 && !isPairwise && /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx("br", {}),
                        /* @__PURE__ */ jsxs("span", { children: [
                          "Identical Positions: ",
                          aaIdenticalPosition
                        ] }),
                        /* @__PURE__ */ jsx("br", {}),
                        /* @__PURE__ */ jsxs("span", { children: [
                          "Identity: ",
                          aaIdentity,
                          "%"
                        ] })
                      ] })
                    ] }) : /* @__PURE__ */ jsxs("span", { children: [
                      sequenceData2.sequence.length,
                      " bps"
                    ] })
                  ] })
                ]
              }
            ),
            /* @__PURE__ */ jsx(
              HorizontalPanelDragHandle,
              {
                onDrag: ({ dx }) => {
                  setNameDivWidth(Math.min(nameDivWidth - dx, width - 20));
                }
              }
            )
          ]
        },
        i
      ),
      handleSelectTrack && !isTemplate && /* @__PURE__ */ jsx(
        "div",
        {
          onClick: () => {
            handleSelectTrack(i);
          },
          style: {
            position: "absolute",
            opacity: 0,
            height: "100%",
            left: nameDivWidth,
            width: linearViewWidth,
            fontWeight: "bolder",
            cursor: "pointer",
            padding: 5,
            textAlign: "center",
            zIndex: 400
          },
          className: "alignmentViewSelectTrackPopover veWhiteBackground",
          children: "Inspect track"
        }
      ),
      /* @__PURE__ */ jsx(
        NonReduxEnhancedLinearView,
        {
          ...rest,
          caretPosition: tempTrimmingCaret[i] || -1,
          selectionLayer: selectionLayer2,
          isInAlignment: true,
          annotationVisibilityOverrides: alignmentVisibilityToolOptions.alignmentAnnotationVisibility,
          linearViewAnnotationLabelVisibilityOverrides: alignmentVisibilityToolOptions.alignmentAnnotationLabelVisibility,
          marginWith: 0,
          orfClicked: annotationClicked,
          primerClicked: annotationClicked,
          translationClicked: annotationClicked,
          cutsiteClicked: annotationClicked,
          translationDoubleClicked: annotationClicked,
          deletionLayerClicked: annotationClicked,
          replacementLayerClicked: annotationClicked,
          featureClicked: annotationClicked,
          featureRightClicked: getFeatureRightClicked(i, alignmentTracks),
          partClicked: annotationClicked,
          searchLayerClicked: annotationClicked,
          editorDragStarted: noop,
          editorDragStopped: noop,
          editorDragged: noop,
          hideName: true,
          sequenceData: sequenceData2,
          tickSpacing,
          allowSeqDataOverride: true,
          editorName: `${isTemplate ? "template_" : ""}alignmentView${i}`,
          alignmentData,
          chromatogramData,
          height: "100%",
          vectorInteractionWrapperStyle: {
            overflowY: "hidden"
          },
          withZoomLinearView: false,
          marginWidth: 0,
          linearViewCharWidth: charWidth,
          ignoreGapsOnHighlight: true,
          ...linearViewOptions && (isFunction(linearViewOptions) ? linearViewOptions({
            index: i,
            isTemplate,
            alignmentVisibilityToolOptions,
            sequenceData: sequenceData2,
            alignmentData,
            chromatogramData
          }) : linearViewOptions),
          additionalSelectionLayers,
          dimensions: {
            width: linearViewWidth
          },
          width: linearViewWidth,
          paddingBottom: 5,
          scrollDataPassed: easyStore.current
        }
      )
    );
    if (isTemplate) return innerRenderItem();
    if (cloneProps)
      return innerRenderItem(cloneProps.provided, cloneProps.snapshot);
    const idToUse = (alignmentData.id || sequenceData2.id || "track") + "_" + i;
    return /* @__PURE__ */ jsx(
      DndDraggable,
      {
        index: i,
        isDragDisabled,
        draggableId: idToUse.toString(),
        children: innerRenderItem
      },
      idToUse.toString()
    );
  };
  const handleResize = throttle(([e]) => {
    easyStore.current.viewportWidth = e.contentRect.width - nameDivWidth || 400;
    setWidth(e.contentRect.width);
  }, 200);
  const removeMinimapHighlightForMouseLeave = () => {
    const minimapLaneEl = document.querySelector(`.minimapLane.lane-hovered`);
    if (!minimapLaneEl) return;
    minimapLaneEl.classList.remove("lane-hovered");
  };
  const updateMinimapHighlightForMouseMove = (event) => {
    latestMouseY.current = getClientY(event);
    updateMinimapHighlight();
  };
  const updateMinimapHighlight = () => {
    const rows = document.querySelectorAll(`.alignmentViewTrackContainer`);
    const rowsLength = document.querySelectorAll(`.minimapLane`).length;
    if (rowsLength <= 4) {
      return;
    }
    some(rows, (rowDomNode) => {
      const boundingRowRect = rowDomNode.getBoundingClientRect();
      if (latestMouseY.current > boundingRowRect.top && latestMouseY.current < boundingRowRect.top + boundingRowRect.height) {
        const prevMinimapLaneEl = document.querySelector(
          `.minimapLane.lane-hovered`
        );
        if (prevMinimapLaneEl) {
          prevMinimapLaneEl.classList.remove("lane-hovered");
        }
        const i = Number(rowDomNode.getAttribute("data-alignment-track-index"));
        const minimapLaneEl = document.querySelector(
          `.minimapLane:nth-child(${i + 1})`
        );
        if (!minimapLaneEl) return;
        minimapLaneEl.classList.add("lane-hovered");
        return true;
      }
    });
  };
  const onTrackDragStart = () => {
    setIsTrackDragging(true);
  };
  const onTrackDragEnd = ({ destination, source }) => {
    setIsTrackDragging(false);
    if (!destination) {
      return;
    }
    upsertAlignmentRun({
      id: alignmentId,
      alignmentTracks: array_move(
        alignmentTracks,
        source.index,
        destination.index
      )
    });
  };
  const getTrackTrimmingOptions = ({
    e,
    allTracks,
    upsertAlignmentRun: upsertAlignmentRun2,
    currentPairwiseAlignmentIndex: currentPairwiseAlignmentIndex2,
    alignmentId: alignmentId2
  }) => {
    const track = getTrackFromEvent(e, allTracks);
    getNearestCursorPositionToMouseEvent(
      rowData.current,
      e,
      ({ nearestCaretPos }) => {
        setTempTrimmingCaret((prev) => ({
          ...prev,
          [track.index]: nearestCaretPos
        }));
        const afterDisabled = nearestCaretPos <= track.alignmentData.trimmedRange?.start;
        const beforeDisabled = nearestCaretPos > track.alignmentData.trimmedRange?.end;
        showContextMenu(
          [
            {
              divider: /* @__PURE__ */ jsx(
                "div",
                {
                  style: {
                    color: "#137cbd",
                    fontSize: 13,
                    fontWeight: "bold"
                  },
                  children: `Trim ${track.sequenceData.name || track.sequenceData.id}...`
                }
              )
            },
            {
              text: "Ignore Before",
              disabled: beforeDisabled,
              icon: "drawer-left-filled",
              onMouseOver: () => !beforeDisabled && setTempTrimBefore((prev) => ({
                ...prev,
                [track.index]: { start: 0, end: nearestCaretPos - 1 }
              })),
              onMouseLeave: () => setTempTrimBefore((prev) => ({
                ...prev,
                [track.index]: void 0
              })),
              onClick: () => {
                updateTrackHelper({
                  currentPairwiseAlignmentIndex: currentPairwiseAlignmentIndex2,
                  upsertAlignmentRun: upsertAlignmentRun2,
                  alignmentId: alignmentId2,
                  alignmentTracks: allTracks,
                  alignmentTrackIndex: track.index,
                  hasBeenTrimmed: true,
                  update: {
                    trimmedRange: {
                      start: nearestCaretPos,
                      end: track.alignmentData.trimmedRange?.end || maxLength - 1
                    }
                  }
                });
              }
            },
            {
              text: "Ignore After",
              disabled: afterDisabled,
              icon: "drawer-right-filled",
              onMouseOver: () => !afterDisabled && setTempTrimAfter((prev) => ({
                ...prev,
                [track.index]: { start: nearestCaretPos, end: maxLength - 1 }
              })),
              onMouseLeave: () => setTempTrimAfter((prev) => ({
                ...prev,
                [track.index]: void 0
              })),
              onClick: () => {
                updateTrackHelper({
                  currentPairwiseAlignmentIndex: currentPairwiseAlignmentIndex2,
                  upsertAlignmentRun: upsertAlignmentRun2,
                  alignmentId: alignmentId2,
                  alignmentTracks: allTracks,
                  alignmentTrackIndex: track.index,
                  hasBeenTrimmed: true,
                  update: {
                    trimmedRange: {
                      start: track.alignmentData.trimmedRange?.start || 0,
                      end: nearestCaretPos - 1
                    }
                  }
                });
              }
            },
            {
              divider: ""
            },
            {
              text: "Clear Trim(s)",
              disabled: !(track?.alignmentData?.trimmedRange?.start > -1),
              icon: "trash",
              onClick: () => {
                updateTrackHelper({
                  currentPairwiseAlignmentIndex: currentPairwiseAlignmentIndex2,
                  upsertAlignmentRun: upsertAlignmentRun2,
                  alignmentId: alignmentId2,
                  alignmentTracks: allTracks,
                  alignmentTrackIndex: track.index,
                  hasBeenTrimmed: false,
                  update: {
                    trimmedRange: void 0
                  }
                });
              }
            }
          ],
          void 0,
          e,
          () => {
            setTempTrimAfter((prev) => ({ ...prev, [track.index]: void 0 }));
          }
        );
      }
    );
    e.preventDefault();
    e.stopPropagation();
  };
  if (!alignmentTracks || !alignmentTracks[0] || !alignmentTracks[0].alignmentData) {
    console.error("corrupted data!", props);
    return "corrupted data!";
  }
  const getTrackVis = (alignmentTracks2, isTemplate, allTracks, aminoAcidAlignmentProperties2, labileSites2) => {
    const labilePositions = aminoAcidAlignmentProperties2?.labileSites.sites.map((ls) => ls.position) || [];
    const rowData2 = {};
    const innerTrackVis = (drop_provided, drop_snapshot) => {
      return /* @__PURE__ */ jsx(
        "div",
        {
          className: "alignmentTracks ",
          style: {
            overflowY: "auto",
            display: "flex",
            zIndex: 10
          },
          children: /* @__PURE__ */ jsx(
            "div",
            {
              style: { overflowX: "auto", width },
              ref: (ref) => {
                if (isTemplate) {
                  alignmentHolderTop.current = ref;
                } else {
                  alignmentHolder.current = ref;
                }
              },
              onContextMenu: (e) => {
                if (!allowTrimming || isTargetWithinEl(e, ".alignmentTrackName")) {
                  return;
                }
                getTrackTrimmingOptions({
                  e,
                  allTracks,
                  upsertAlignmentRun,
                  alignmentId,
                  currentPairwiseAlignmentIndex
                });
              },
              onMouseLeave: removeMinimapHighlightForMouseLeave,
              onMouseMove: updateMinimapHighlightForMouseMove,
              dataname: "scrollGroup",
              className: "alignmentHolder",
              onScroll: isTemplate ? handleTopScroll : handleScroll,
              children: /* @__PURE__ */ jsx(
                ReactDraggable,
                {
                  disabled: isTrackDragging,
                  bounds: { top: 0, left: 0, right: 0, bottom: 0 },
                  onDrag: noClickDragHandlers ? noop : (event) => {
                    if (isTrackDragging) return;
                    getNearestCursorPositionToMouseEvent(
                      rowData2,
                      event,
                      editorDragged
                    );
                  },
                  onStart: noClickDragHandlers ? noop : (event) => {
                    if (isTargetWithinEl(event, ".alignmentTrackName")) {
                      setIsTrackDragging(true);
                      return;
                    }
                    if (isTrackDragging) return;
                    getNearestCursorPositionToMouseEvent(
                      rowData2,
                      event,
                      editorDragStarted
                    );
                  },
                  onStop: noClickDragHandlers ? noop : (...args) => {
                    setTimeout(() => {
                      setIsTrackDragging(false);
                    }, 0);
                    editorDragStopped(...args);
                  },
                  children: /* @__PURE__ */ jsxs(
                    "div",
                    {
                      ref: veTracksAndAlignmentHolder,
                      className: classNames("veTracksAndAlignmentHolder", {
                        isTrackDragging
                      }),
                      onClick: noClickDragHandlers ? noop : (event) => {
                        if (isTrackDragging) return;
                        if (isTargetWithinEl(event, ".alignmentTrackName")) {
                          return;
                        }
                        getNearestCursorPositionToMouseEvent(
                          rowData2,
                          event,
                          editorClicked
                        );
                      },
                      children: [
                        /* @__PURE__ */ jsx(
                          PerformantSelectionLayer,
                          {
                            leftMargin: nameDivWidth,
                            className: "veAlignmentSelectionLayer",
                            isDraggable: true,
                            selectionLayerRightClicked: selectionLayerRightClicked ? (...args) => {
                              selectionLayerRightClicked(...args, props);
                            } : (...args) => {
                              const { event } = args[0];
                              const track = getTrackFromEvent(event, allTracks);
                              const alignmentData = track.alignmentData;
                              const name = getTrackDisplayName(track);
                              const copySpecificAlignmentFasta = async () => {
                                const { selectionLayer: selectionLayer2 } = store.getState().VectorEditor.__allEditorsOptions.alignments[id] || {};
                                const seqDataToCopy = getSequenceDataBetweenRange(
                                  alignmentData,
                                  selectionLayer2
                                ).sequence;
                                const seqDataToCopyAsFasta = `>${name}\r
${seqDataToCopy}\r
`;
                                await navigator.clipboard.writeText(
                                  seqDataToCopyAsFasta
                                );
                              };
                              const copySpecificAlignment = async () => {
                                const { selectionLayer: selectionLayer2 } = store.getState().VectorEditor.__allEditorsOptions.alignments[id] || {};
                                const seqDataToCopy = getSequenceDataBetweenRange(
                                  alignmentData,
                                  selectionLayer2
                                ).sequence;
                                await navigator.clipboard.writeText(seqDataToCopy);
                              };
                              const copyAllAlignmentsFastaText = async () => {
                                await navigator.clipboard.writeText(
                                  getAllAlignmentsFastaText()
                                );
                              };
                              showContextMenu(
                                [
                                  ...additionalSelectionLayerRightClickedOptions ? additionalSelectionLayerRightClickedOptions(
                                    ...args,
                                    props
                                  ) : [],
                                  {
                                    text: "Copy Selection of All Alignments as Fasta",
                                    className: "copyAllAlignmentsFastaClipboardHelper",
                                    hotkey: "cmd+c",
                                    onClick: () => {
                                      copyAllAlignmentsFastaText();
                                      window.toastr.success("Selection Copied");
                                    }
                                  },
                                  {
                                    text: `Copy Selection of ${name} as Fasta`,
                                    className: "copySpecificAlignmentFastaClipboardHelper",
                                    onClick: (e) => {
                                      copySpecificAlignmentFasta(e);
                                      window.toastr.success(
                                        "Selection Copied As Fasta"
                                      );
                                    }
                                  },
                                  {
                                    text: `Copy Selection of ${name}`,
                                    className: "copySpecificAlignmentAsPlainClipboardHelper",
                                    onClick: () => {
                                      copySpecificAlignment();
                                      window.toastr.success("Selection Copied");
                                    }
                                  }
                                ],
                                void 0,
                                event
                              );
                            },
                            easyStore: easyStore.current,
                            sequenceLength: maxLength,
                            charWidth,
                            row: { start: 0, end: maxLength - 1 }
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          PerformantCaret,
                          {
                            leftMargin: nameDivWidth,
                            className: "veAlignmentSelectionLayer",
                            isDraggable: true,
                            sequenceLength: maxLength,
                            charWidth,
                            row: { start: 0, end: maxLength - 1 },
                            easyStore: easyStore.current
                          }
                        ),
                        labileSites2 && labilePositions.length > 0 && /* @__PURE__ */ jsx(
                          LabileSitesLayer,
                          {
                            leftMargin: nameDivWidth,
                            charWidth,
                            positionsToMark: labilePositions
                          }
                        ),
                        isTemplate ? renderItem(0, 0, isTemplate) : /* @__PURE__ */ jsx(
                          ReactList,
                          {
                            ref: (c) => {
                              InfiniteScroller.current = c;
                              const domNode = ReactDOM.findDOMNode(c);
                              if (domNode instanceof HTMLElement) {
                                drop_provided.innerRef(domNode);
                              }
                            },
                            type: "variable",
                            itemSizeEstimator: estimateRowHeight,
                            itemRenderer: renderItem,
                            length: alignmentTracks2.length + (drop_snapshot.isUsingPlaceholder ? 1 : 0)
                          },
                          `${alignmentId || stateTrackingId || "alignment"}_${alignmentTracks2.length}_${charWidth}`
                        )
                      ]
                    }
                  )
                }
              )
            }
          )
        }
      );
    };
    if (isTemplate) return innerTrackVis();
    else
      return /* @__PURE__ */ jsx(
        Droppable,
        {
          mode: "virtual",
          renderClone: (provided, snapshot, { source: { index } }) => {
            return renderItem(index, index, false, {
              provided,
              snapshot
            });
          },
          direction: "vertical",
          droppableId: "droppable" + isTemplate ? "_no_drop" : "",
          children: innerTrackVis
        }
      );
  };
  const [firstTrack, ...otherTracks] = alignmentTracks;
  const totalWidthOfMinimap = width;
  const totalWidthInAlignmentView = 14 * getSequenceLength();
  const minSliderSize = Math.min(
    totalWidthOfMinimap * (totalWidthOfMinimap / totalWidthInAlignmentView),
    totalWidthOfMinimap
  );
  const viewportHeight = Math.max(
    document.documentElement.clientHeight,
    window.innerHeight || 0
  );
  const pinchHandler = {
    onPinch: ({ delta: [d] }) => {
      bindOutsideChangeHelper.current.triggerChange(
        ({ value, changeValue }) => {
          if (d > 0) {
            if (value > 8) {
              changeValue(value + 0.4);
            } else {
              changeValue(value + 0.2);
            }
          } else if (d < 0) {
            if (value > 8) {
              changeValue(value - 0.4);
            } else {
              changeValue(value - 0.2);
            }
          }
        }
      );
      updateLabelsForInViewFeatures();
    }
  };
  const { labileSites } = alignmentVisibilityToolOptions.alignmentAnnotationVisibility;
  return /* @__PURE__ */ jsx(PinchHelper, { ...pinchHandler, children: /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        flexDirection: "row"
      },
      children: [
        /* @__PURE__ */ jsx(ResizeSensor, { onResize: handleResize, children: /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              height: height || (isPairwise ? "auto" : viewportHeight * 0.88),
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              position: "relative",
              overflowY: "auto",
              ...style
              // borderTop: "1px solid black"
            },
            tabIndex: 0,
            className: "alignmentView",
            children: [
              /* @__PURE__ */ jsx(
                DragDropContext,
                {
                  onDragStart: onTrackDragStart,
                  onDragEnd: onTrackDragEnd,
                  children: /* @__PURE__ */ jsxs(
                    "div",
                    {
                      style: {
                        display: "flex",
                        flexDirection: "column",
                        position: "relative",
                        width: "100%",
                        overflowY: "auto"
                      },
                      className: "alignmentView-top-container",
                      children: [
                        /* @__PURE__ */ jsxs(
                          "div",
                          {
                            style: {
                              paddingTop: "3px",
                              paddingBottom: "5px",
                              borderBottom: "1px solid",
                              display: "flex",
                              minHeight: "32px",
                              width: "100%",
                              flexWrap: "nowrap",
                              flexDirection: "row",
                              flex: "0 0 auto"
                            },
                            className: "ve-alignment-top-bar",
                            children: [
                              additionalTopLeftEl,
                              handleBackButtonClicked && /* @__PURE__ */ jsx(Tooltip, { content: "Back to Pairwise Alignment Overview", children: /* @__PURE__ */ jsx(
                                Button,
                                {
                                  icon: "arrow-left",
                                  onClick: () => {
                                    handleBackButtonClicked();
                                    caretPositionUpdate(-1);
                                  },
                                  small: true,
                                  intent: Intent.PRIMARY,
                                  minimal: true,
                                  style: { marginRight: 10 },
                                  className: "alignmentViewBackButton"
                                }
                              ) }),
                              /* @__PURE__ */ jsxs("div", { style: { display: "flex" }, children: [
                                /* @__PURE__ */ jsx(
                                  EditableText,
                                  {
                                    disabled: !handleAlignmentRename,
                                    onChange: (v) => {
                                      setAlignmentName(v);
                                    },
                                    maxLength: 399,
                                    value: alignmentName,
                                    onConfirm: async (v) => {
                                      if (!v) {
                                        setAlignmentName(_alignmentName);
                                        return;
                                      }
                                      if (v === _alignmentName) {
                                        return;
                                      }
                                      setSaveMessage("Alignment Renaming..");
                                      setSaveMessageLoading(true);
                                      await handleAlignmentRename(v, props);
                                      setSaveMessage("Rename Successful");
                                      setSaveMessageLoading(false);
                                      setTimeout(() => {
                                        setSaveMessage(void 0);
                                        setSaveMessageLoading(false);
                                      }, 5e3);
                                    },
                                    selectAllOnFocus: true,
                                    className: "veAlignmentName"
                                  }
                                ),
                                "\xA0\xA0\xA0",
                                /* @__PURE__ */ jsx(
                                  "div",
                                  {
                                    className: "veAlignmentType",
                                    style: {
                                      paddingTop: "3px",
                                      fontSize: "14px",
                                      color: "grey",
                                      maxWidth: "300px",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      whiteSpace: "nowrap"
                                    },
                                    "data-title": alignmentType || "Unknown Alignment Type",
                                    children: alignmentType || "Unknown Alignment Type"
                                  }
                                )
                              ] }),
                              unmappedSeqs && /* @__PURE__ */ jsx(
                                InfoHelper,
                                {
                                  size: 20,
                                  content: /* @__PURE__ */ jsxs("div", { children: [
                                    "This alignment had sequences that did not map to the template sequence:",
                                    unmappedSeqs.map(({ sequenceData: sequenceData2 }, i) => /* @__PURE__ */ jsx("div", { children: sequenceData2.name }, i))
                                  ] }),
                                  intent: "warning",
                                  icon: "warning-sign"
                                }
                              ),
                              !isInPairwiseOverviewView && /* @__PURE__ */ jsx(
                                UncontrolledSliderWithPlusMinusBtns,
                                {
                                  noWraparound: true,
                                  bindOutsideChangeHelper: bindOutsideChangeHelper.current,
                                  onClick: () => {
                                    setTimeout(scrollToCaret, 0);
                                  },
                                  minCharWidth: getMinCharWidth(),
                                  onChange: async (zoomLvl) => {
                                    isZooming.current = true;
                                    setTimeout(() => {
                                      isZooming.current = false;
                                    }, 10);
                                    const minCharWidth = getMinCharWidth();
                                    const scaleFactor = Math.pow(12 / minCharWidth, 1 / 10);
                                    const newCharWidth = minCharWidth * Math.pow(scaleFactor, zoomLvl);
                                    await setCharWidthInLinearView({
                                      charWidthInLinearView: newCharWidth
                                    });
                                    await scrollToCaret();
                                    await updateLabelsForInViewFeatures({
                                      rectElement: ".alignmentHolder"
                                    });
                                  },
                                  coerceInitialValue,
                                  title: "Adjust Zoom Level",
                                  style: { paddingTop: "4px", width: 100 },
                                  className: "veZoomAlignmentSlider ove-slider",
                                  labelRenderer: false,
                                  initialValue: charWidth,
                                  stepSize: 0.05,
                                  max: 10,
                                  min: 0,
                                  clickStepSize: 0.5
                                }
                              ),
                              !noVisibilityOptions && !isInPairwiseOverviewView && /* @__PURE__ */ jsx(
                                AlignmentVisibilityTool,
                                {
                                  currentPairwiseAlignmentIndex,
                                  ...alignmentVisibilityToolOptions
                                }
                              ),
                              additionalTopEl,
                              saveMessage && /* @__PURE__ */ jsxs(
                                "div",
                                {
                                  className: "ove-menu-toast",
                                  style: {
                                    display: "flex",
                                    alignItems: "center",
                                    marginLeft: "auto",
                                    marginRight: 10
                                  },
                                  children: [
                                    saveMessageLoading ? /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(Spinner, { size: 15 }) }) : /* @__PURE__ */ jsx(Icon, { icon: "tick-circle", intent: "success" }),
                                    " ",
                                    "\xA0",
                                    saveMessage
                                  ]
                                }
                              ),
                              !propertySidePanel.isOpen && /* @__PURE__ */ jsx(
                                Button,
                                {
                                  small: true,
                                  minimal: true,
                                  className: "showTrackPropertiesBtn",
                                  icon: "menu-closed",
                                  intent: "primary",
                                  style: { marginLeft: "auto" },
                                  onClick: () => {
                                    setPropertySidePanel((prev) => {
                                      return {
                                        ...prev,
                                        isOpen: true
                                      };
                                    });
                                  },
                                  "data-tip": "Show Track Properties"
                                }
                              )
                            ]
                          }
                        ),
                        hasTemplate ? /* @__PURE__ */ jsxs(Fragment, { children: [
                          /* @__PURE__ */ jsx("div", { className: "alignmentTrackFixedToTop", children: getTrackVis(
                            [firstTrack],
                            true,
                            alignmentTracks,
                            aminoAcidAlignmentProperties,
                            labileSites
                          ) }),
                          getTrackVis(
                            otherTracks,
                            false,
                            alignmentTracks,
                            aminoAcidAlignmentProperties,
                            labileSites
                          )
                        ] }) : getTrackVis(
                          alignmentTracks,
                          false,
                          alignmentTracks,
                          aminoAcidAlignmentProperties,
                          labileSites
                        )
                      ]
                    }
                  )
                }
              ),
              !isInPairwiseOverviewView && /* @__PURE__ */ jsx(
                "div",
                {
                  className: "alignmentViewBottomBar",
                  style: {
                    // flexGrow: 1,
                    // minHeight: "-webkit-min-content", //https://stackoverflow.com/questions/28029736/how-to-prevent-a-flex-item-from-shrinking-smaller-than-its-content
                    maxHeight: 210,
                    marginTop: 4,
                    paddingTop: 4,
                    borderTop: "1px solid lightgrey",
                    display: "flex"
                  },
                  children: /* @__PURE__ */ jsx(
                    Minimap,
                    {
                      selectionLayerComp: /* @__PURE__ */ jsxs(Fragment, { children: [
                        /* @__PURE__ */ jsx(
                          PerformantSelectionLayer,
                          {
                            is: true,
                            hideCarets: true,
                            className: "veAlignmentSelectionLayer veMinimapSelectionLayer",
                            easyStore: easyStore.current,
                            sequenceLength: maxLength,
                            charWidth: getMinCharWidth(true),
                            row: { start: 0, end: maxLength - 1 }
                          }
                        ),
                        /* @__PURE__ */ jsx(
                          PerformantCaret,
                          {
                            style: {
                              opacity: 0.2
                            },
                            className: "veAlignmentSelectionLayer veMinimapSelectionLayer",
                            sequenceLength: maxLength,
                            charWidth: getMinCharWidth(true),
                            row: { start: 0, end: maxLength - 1 },
                            easyStore: easyStore.current
                          }
                        )
                      ] }),
                      alignmentTracks,
                      dimensions: {
                        width: Math.max(width, 10) || 10
                      },
                      nameDivOffsetPercent: 0,
                      scrollYToTrack,
                      onSizeAdjust: onMinimapSizeAdjust,
                      minSliderSize,
                      laneHeight: minimapLaneHeight || (alignmentTracks.length > 5 ? 10 : 17),
                      laneSpacing: minimapLaneSpacing || (alignmentTracks.length > 5 ? 2 : 1),
                      easyStore: easyStore.current,
                      numBpsShownInLinearView: getNumBpsShownInLinearView(),
                      scrollAlignmentView: false,
                      onMinimapScrollX: scrollAlignmentToPercent
                    }
                  )
                }
              ),
              /* @__PURE__ */ jsx(
                GlobalDialog,
                {}
              )
            ]
          }
        ) }),
        propertySidePanel.isOpen && /* @__PURE__ */ jsx(
          PropertySidePanel,
          {
            properties: propertySidePanel,
            setProperties: setPropertySidePanel,
            style: {
              height: viewportHeight * 0.88
            }
          }
        )
      ]
    }
  ) });
};
export default compose(
  withStore,
  withEditorProps,
  connect(
    (state, ownProps) => {
      const {
        VectorEditor: {
          __allEditorsOptions: { alignments }
        }
      } = state;
      const { id: alignmentId, updateAlignmentViewVisibility } = ownProps;
      const alignment = { ...alignments[alignmentId], id: alignmentId };
      const {
        stateTrackingId,
        unmappedSeqs,
        alignmentTracks,
        pairwiseAlignments,
        alignmentType,
        scrollPercentageToJumpTo,
        pairwiseOverviewAlignmentTracks,
        loading,
        name,
        alignmentAnnotationVisibility,
        alignmentAnnotationLabelVisibility,
        caretPosition = -1,
        selectionLayer = { start: -1, end: -1 }
      } = alignment || {};
      if (loading) {
        return {
          loading: true
        };
      }
      if ((!alignmentTracks || !alignmentTracks.length) && (!pairwiseAlignments || !pairwiseAlignments.length))
        return {
          noTracks: true
        };
      const template = pairwiseAlignments ? pairwiseAlignments[0] && pairwiseAlignments[0][0] : alignmentTracks && alignmentTracks[0];
      if (!template || !template.alignmentData) {
        return {
          noTracks: true
        };
      }
      const templateLength = template.alignmentData.sequence.length;
      const alignmentAnnotationsToToggle = [
        "features",
        "primers",
        "parts",
        "sequence",
        "reverseSequence",
        "axis",
        "translations",
        "cdsFeatureTranslations",
        "chromatogram",
        "dnaColors",
        "physicalProperties",
        "serineThreonine",
        "labileSites",
        "colorScheme",
        "plot",
        "conservation",
        "properties",
        "hydrophobicity",
        "polar",
        "negative",
        "positive",
        "charged",
        "aliphatic",
        "aromatic",
        "compactNames"
      ];
      const togglableAlignmentAnnotationSettings = {};
      map(alignmentAnnotationsToToggle, (annotation) => {
        if (annotation in alignmentAnnotationVisibility) {
          togglableAlignmentAnnotationSettings[annotation] = alignmentAnnotationVisibility[annotation];
        }
      });
      const annotationsWithCounts = [];
      if (alignmentTracks) {
        const tracks = parseTracks(alignmentTracks);
        const labileSites = getLabileSites(tracks, 0.5);
        let totalNumOfFeatures = 0;
        let totalNumOfParts = 0;
        let totalNumOfPrimers = 0;
        alignmentTracks.forEach((seq) => {
          if (seq.sequenceData.features) {
            totalNumOfFeatures += seq.sequenceData.features.length;
          }
          if (seq.sequenceData.parts) {
            totalNumOfParts += seq.sequenceData.parts.length;
          }
          if (seq.sequenceData.primers) {
            totalNumOfPrimers += seq.sequenceData.primers.length;
          }
        });
        annotationsWithCounts.push({
          features: totalNumOfFeatures,
          parts: totalNumOfParts,
          primers: totalNumOfPrimers,
          labileSites: labileSites.sites?.length ?? 0
        });
      } else if (pairwiseAlignments) {
        pairwiseAlignments.forEach((pairwise) => {
          let totalNumOfFeatures = 0;
          let totalNumOfParts = 0;
          let totalNumOfPrimers = 0;
          pairwise.forEach((seq) => {
            if (seq.sequenceData.features) {
              totalNumOfFeatures += seq.sequenceData.features.length;
            }
            if (seq.sequenceData.parts) {
              totalNumOfParts += seq.sequenceData.parts.length;
            }
            if (seq.sequenceData.primers) {
              totalNumOfPrimers += seq.sequenceData.primers.length;
            }
          });
          annotationsWithCounts.push({
            features: totalNumOfFeatures,
            parts: totalNumOfParts,
            primers: totalNumOfPrimers
          });
        });
      }
      return {
        isAlignment: true,
        selectionLayer,
        unmappedSeqs,
        caretPosition,
        alignmentId,
        ...name && { alignmentName: name },
        stateTrackingId,
        sequenceData: {
          //pass fake seq data in so editor interactions work
          sequence: Array.from(templateLength).map(() => "a").join("")
        },
        pairwiseAlignments,
        alignmentType,
        alignmentTracks,
        scrollPercentageToJumpTo,
        pairwiseOverviewAlignmentTracks,
        //manipulate the props coming in so we can pass a single clean prop to the visibility options tool
        alignmentVisibilityToolOptions: {
          alignmentAnnotationVisibility,
          alignmentAnnotationLabelVisibility,
          alignmentAnnotationVisibilityToggle: (updates) => {
            setTimeout(() => {
              updateLabelsForInViewFeatures({
                rectElement: ".alignmentHolder"
              });
            }, 0);
            updateAlignmentViewVisibility({
              ...alignment,
              alignmentAnnotationVisibility: {
                ...alignment.alignmentAnnotationVisibility,
                ...updates
              }
            });
          },
          alignmentAnnotationLabelVisibilityToggle: (name2) => {
            updateAlignmentViewVisibility({
              ...alignment,
              alignmentAnnotationLabelVisibility: {
                ...alignment.alignmentAnnotationLabelVisibility,
                [name2]: !alignment.alignmentAnnotationLabelVisibility[name2]
              }
            });
          },
          togglableAlignmentAnnotationSettings,
          annotationsWithCounts
        }
      };
    },
    {
      ...alignmentActions
    }
  ),
  branch(
    ({ loading }) => loading,
    renderComponent(() => {
      return /* @__PURE__ */ jsx(Loading, { bounce: true });
    })
  ),
  branch(
    ({ noTracks }) => noTracks,
    renderComponent(({ onDeleteAllFailed }) => {
      return /* @__PURE__ */ jsxs(
        "div",
        {
          style: {
            padding: 20,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: 150
          },
          children: [
            /* @__PURE__ */ jsx("div", { style: { fontSize: 18, marginBottom: 20 }, children: "No Tracks Found" }),
            onDeleteAllFailed && /* @__PURE__ */ jsx(
              Button,
              {
                intent: Intent.DANGER,
                large: true,
                onClick: onDeleteAllFailed,
                icon: "trash",
                text: "Delete all failed alignment files"
              }
            )
          ]
        }
      );
    })
  ),
  branch(
    ({ pairwiseAlignments }) => pairwiseAlignments,
    renderComponent((props) => {
      return /* @__PURE__ */ jsx(PairwiseAlignmentView, { ...props });
    })
  )
)(AlignmentView);
const PerformantCaret = view(({ easyStore, ...rest }) => {
  return /* @__PURE__ */ jsx(Caret, { caretPosition: easyStore.caretPosition, ...rest });
});
function cleanTracks(alignmentTracks) {
  return alignmentTracks.map((t) => {
    return omit(t, [
      "matchHighlightRanges",
      "additionalSelectionLayers",
      "mismatches"
    ]);
  });
}
